export default __webpack_public_path__ + "static/media/No_Contact2.9a5397b0.svg";